module.exports = __webpack_public_path__ + "static/img/robert_1000.d5c6ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/robert_1000.jpg
// module id = Nwr9
// module chunks = 1